<main class="local-page">
  <section class="local-hero">
    <div class="container-xl">
      <div class="row align-items-center g-4">
        <div class="col-12 col-lg-6">
          <p class="eyebrow"><i class="fa-solid fa-location-dot"></i> SAMI PULIZIE · SEDE DI GIULIANOVA</p>
          <h1>Pulizie a Giulianova e Teramo</h1>
          <p class="lead">
            Pulizie per condomini, uffici, attività e abitazioni. Contatta la sede di Giulianova:
            concordiamo un sopralluogo gratuito e prepariamo un preventivo su misura, senza impegno.
          </p>
          <p class="branch-contact">
            <i class="fa-solid fa-location-dot"></i>
            <strong>Corso Nazario Sauro 118, Giulianova (TE)</strong>
            <span aria-hidden="true">·</span>
            <a href="tel:0859155805">Tel. 085 9155805</a>
            <span aria-hidden="true">·</span>
            <a href="mailto:commerciale.te@samipulizie.it">commerciale.te@samipulizie.it</a>
          </p>
          <div class="actions">
            <a class="btn-sami" routerLink="/preventivo">Richiedi un preventivo gratuito</a>
            <a class="btn-sami-outline" href="tel:0859155805">Chiama la sede di Giulianova</a>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <img
            class="local-hero-img"
            src="assets/family.JPG"
            alt="Foto di gruppo davanti alla sede SAMI Pulizie"
            width="1600"
            height="1200"
            loading="eager"
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="section-title">Servizi di pulizia disponibili nel Teramano</h2>
        <p class="section-subtitle">Un unico referente e un piano costruito sulle esigenze del tuo ambiente.</p>
      </div>
      <div class="service-grid">
        <article class="local-card card-sami" *ngFor="let service of services">
          <h3>{{ service[0] }}</h3>
          <p>{{ service[1] }}</p>
          <a [routerLink]="service[2]">Scopri il servizio <span aria-hidden="true">→</span></a>
        </article>
      </div>
    </div>
  </section>

  <section class="section coverage">
    <div class="container-xl coverage-layout">
      <div>
        <p class="eyebrow">COPERTURA TERRITORIALE</p>
        <h2 class="section-title">Dalla costa alla città di Teramo</h2>
        <p>
          Organizziamo interventi continuativi e straordinari lungo la costa teramana e nei principali
          centri dell’entroterra. Per località non elencate, contattaci: verificheremo subito la disponibilità.
        </p>
      </div>
      <ul class="area-list" aria-label="Comuni serviti in provincia di Teramo">
        <li *ngFor="let area of areas"><i class="fa-solid fa-check"></i> {{ area }}</li>
      </ul>
    </div>
  </section>

  <section class="section">
    <div class="container-xl faq-wrap">
      <div class="section-head text-center">
        <h2 class="section-title">Domande frequenti</h2>
      </div>
      <details class="faq card-sami" *ngFor="let faq of faqs">
        <summary>{{ faq.question }}</summary>
        <p>{{ faq.answer }}</p>
      </details>
    </div>
  </section>

  <section class="local-cta">
    <div class="container-xl text-center">
      <h2>Richiedi il tuo servizio a Giulianova o Teramo</h2>
      <p>Raccontaci di quali spazi vuoi occuparti: prepareremo una proposta chiara e personalizzata.</p>
      <a class="btn btn-light" routerLink="/preventivo">Richiedi il preventivo</a>
    </div>
  </section>

  <div class="whatsapp-float">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener"
      aria-label="Chatta con SAMI Pulizie su WhatsApp"
      title="Scrivici su WhatsApp">
      <i class="fa-brands fa-whatsapp"></i>
    </a>
  </div>

  <section class="section branch-map" aria-labelledby="branch-map-title">
    <div class="container-xl">
      <div class="section-head text-center">
        <p class="eyebrow">SEDE DI GIULIANOVA</p>
        <h2 id="branch-map-title" class="section-title">Ci trovi in Corso Nazario Sauro 118</h2>
        <p class="section-subtitle">
          Sede SAMI Pulizie a Giulianova: contattaci per concordare il servizio.
        </p>
      </div>
      <div class="map-shell">
        <iframe
          title="Mappa sede SAMI Pulizie - Corso Nazario Sauro 118, Giulianova"
          src="https://www.google.com/maps?q=42.7533741%2C13.9669969&output=embed"
          width="1200"
          height="520"
          loading="lazy"
          allowfullscreen
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
      <div class="map-actions text-center">
        <a
          class="btn-sami-outline"
          href="https://www.google.com/maps/search/?api=1&query=42.7533741%2C13.9669969"
          target="_blank"
          rel="noopener noreferrer">
          Apri le indicazioni su Google Maps
        </a>
      </div>
    </div>
  </section>
</main>
